import { fullUrl } from "../../utile/utile.api";
import change from "./change";
import reset from "./reset";
import resetEmail from "./reset-email";

const path = '/password';

const password = (url: string) => () => {
  const full = fullUrl(url, path);
  return ({
    change: () => change(full)(),
    reset: () => reset(full)(),
    resetEmail: () => resetEmail(full)(),
  })
}

export default password;
